export const customer_by_pk = /* GraphQL */ `
  query customer_by_pk($id: String!) {
    customer_by_pk(id: $id) {
      type
      preferred_name
      phone_work
      phone_home
      phone_fax
      phone_cell
      last_name
      id
      first_name
      company_occupation
      unit_system
      company_name
      company_website
    }
  }
`;

export const customer = /* GraphQL */ `
  query customer($where: customer_bool_exp) {
    customer(where: $where) {
      type
      preferred_name
      phone_work
      phone_home
      phone_fax
      phone_cell
      last_name
      id
      first_name
      company_occupation
      unit_system
      company_name
      company_website
      updated_at
      created_at
      cameras_aggregate {
      aggregate {
        count
      }
    }
      sites_aggregate {
      aggregate {
        count
      }
    }
    wifis_aggregate {
      aggregate {
        count
      }
    }
      addresses(order_by: {type: desc}) {
      updated_at
      type
      province
      postal_code
      line_2
      line_1
      deleted_at
      customer_id
      created_at
      country
      city
    }
      notification_preferences {
      warning_sms_frequency
      warning_email_frequency
      warning_call_frequency
      updated_at
      info_sms_frequency
      info_email_frequency
      info_call_frequency
      deleted_at
      customer_id
      created_at
      alert_sms_frequency
      alert_email_frequency
      alert_call_frequency
    }
    }
  }
`;

export const admin_note = /* GraphQL */ `
query admin_note($where: admin_note_bool_exp = {}) {
  admin_note(where: $where) {
    wifi_id
    updated_at
    id
    datetime
    deleted_at
    customer_id
    created_at
    comment
    camera_id
    author
  }
}`

export const site = /* GraphQL */ `
query site($where: site_bool_exp = {}) {
  site(where: $where) {
     weight_scale
    updated_at
    timezone
    rfid_reader
    public_ip
    perimeter_long
    perimeter_lat
    operation_type
    name
    map_zoom_level
    isp_upload_mbps
    isp_download_mbps
    isp_datacap_gb
    isp_billing_cycle_day
    internet_provider
    id
    deleted_at
    customer_id
    created_at
    coordinates_long
    coordinates_lat
    community_pasture_used
    assigned_id
    area
    customer {
      id
      first_name
      last_name
    }
  }
}`

export const camera = /* GraphQL */ `
query camera($where: camera_bool_exp = {}, $order_by: [camera_order_by!], $limit: Int, $offset: Int) {
  camera(where: $where, order_by: $order_by, offset: $offset, limit: $limit) {
     updated_at
    status
    site_id
    shipped
    predator_notifications_enabled
    name
    model
    map_icon_color
    manufacturer
    latest_upload_type
    latest_upload_source
    latest_upload_resolution
    latest_upload_fps
    latest_upload_corrupted
    latest_upload_bitrate_kbps
    site {
      name
      id
    }
    latest_upload
    last_video_upload
    last_status_update
    inventory_number
    id
    footage_thumbnail_url
    estrus_notifications_enabled
    deleted_at
    customer_id
    customer {
      first_name
      last_name
      id
    }
    created_at
    coordinates_long
    coordinates_lat
    calving_notifications_enabled
    broken_reason
    broken
  
  }
}`

export const camera_aggregate = /* GraphQL */ `
query camera_aggregate($where: camera_bool_exp = {}) {
  camera_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}`

export const wifi = /* GraphQL */ `
query wifi($where: wifi_bool_exp) {
  wifi(where: $where) {
    updated_at
    status
    site_id
    shipped
    model
    map_icon_color
    manufacturer
    inventory_number
    id
    device_type
    deleted_at
    customer_id
    created_at
    coordinates_lat
    coordinates_long
    customer {
      first_name
      last_name
      id
    }
  }
}`

export const inference_media_video = /* GraphQL */ `
  query inference_media(
    $where: inference_media_bool_exp
    $order_by: [inference_media_order_by!]
    $limit: Int
    $offset: Int
  ) {
    inference_media(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      width
      uploaded_at
      ratio
      num_frames_inferred
      num_frames
      media_type
      media_timestamp_to_inference
      media_timestamp
      keypoint_type
      json_type
      inference_to_upload
      inference_start
      height
      inference_end
      fps
      customer_id
      camera_id
    }
  }
`;
export const inference_media_aggregate = /* GraphQL */ `
  query inference_media_aggregate(
    $where: inference_media_bool_exp
    $order_by: [inference_media_order_by!]
    $limit: Int
    $offset: Int
  ) {
    inference_media_aggregate(
      where: $where
      order_by: $order_by
      limit: $limit
      offset: $offset
    ) {
      aggregate {
        count
      }
    }
  }
`;